import React from 'react';

function EmailIcon({ width = 32, height = 32, ...rest }) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" {...rest}>
      <g>
        <path d="M31.1462437,5 C31.5441275,5 31.872224,5.29791867 31.9241437,5.68139166 L31.9313011,5.78793684 L31.9313011,27.095263 C31.9313011,27.4925362 31.6363617,27.823561 31.2528721,27.875973 L31.1462437,27.8831998 L0.785057471,27.8831998 C0.387173614,27.8831998 0.0590771478,27.5852811 0.00715748564,27.2018081 L0,27.095263 L0,5.78793684 C0,5.39066358 0.294939479,5.05963881 0.678429021,5.00722686 L0.785057471,5 L31.1462437,5 Z M30.93,6.563 L19.3138215,16.7852493 C17.4113578,18.4597683 14.3762498,18.4911677 12.4247108,16.8952619 L12.2393092,16.7357399 L11.273,15.86 L11.9204089,16.5068618 L1.564,26.883 L30.298,26.883 L19.9421934,16.5068618 L20.6500089,15.8004644 L30.93,26.101 L30.93,6.563 Z M0.999,6.563 L0.999,26.034 L11.209,15.803 L0.999,6.563 Z M30.056,6 L1.866,6 L12.9103211,15.9942933 C14.4174953,17.3583561 16.8867816,17.4240618 18.4798589,16.178366 L18.6531683,16.034558 L30.056,6 Z" />
      </g>
    </svg>
  );
}

export default EmailIcon;
